// The name and line of the "A story in a chart" series, shared by the
// stories, the hub, the dashboard card and the link previews' source data.
export const STORY_SERIES = "A story in a chart";
export const STORY_SERIES_TAGLINE = "Famous wine papers and datasets, brought to life one chart at a time.";
